import { render, staticRenderFns } from "./GroupExercisesWidget.vue?vue&type=template&id=21473a20&scoped=true"
import script from "./GroupExercisesWidget.vue?vue&type=script&lang=js"
export * from "./GroupExercisesWidget.vue?vue&type=script&lang=js"
import style0 from "./GroupExercisesWidget.vue?vue&type=style&index=0&id=21473a20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21473a20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21473a20')) {
      api.createRecord('21473a20', component.options)
    } else {
      api.reload('21473a20', component.options)
    }
    module.hot.accept("./GroupExercisesWidget.vue?vue&type=template&id=21473a20&scoped=true", function () {
      api.rerender('21473a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/GroupExercisesWidget.vue"
export default component.exports